var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.video.id)?_c('youtube',{ref:"youtube",staticClass:"w-full h-full",attrs:{"player-vars":_vm.playerVars,"video-id":_vm.videoId},on:{"ended":_vm.ended}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23c94cba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/server/components/Videos/VideoYoutube.vue
// module id = null
// module chunks = 